import React, { useState } from 'react'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import Icon from 'components/_UI/Icon';
import Text from 'components/_UI/Text';
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { Column } from 'styled/alignment/Column';
import { useUser } from 'context/user/User';
import paths from 'routes/paths';
import indexPriority from 'theme/z-index';
// import useAuth from 'hooks/useAuth';
import Button from 'components/_UI/Button';
import { Plus, Tag } from 'lucide-react';
import LoginModal from 'modules/onboarding/sign-in/LoginModal';
import { useOnSelectMenu } from 'context/general/OnSelectMenu';
import ProfileMenu from 'components/commons/ProfileMenu';
import ROLES from 'helpers/roles';
import HeaderFilters from 'modules/_common/HeaderFilters';
import { useAuth } from 'context/auth/Auth';
import { useShowSearchOverlay } from 'context/general/ShowSearchOverlay';
import { useEventFilter } from 'context/events/EventFilter';
import { useEstablishmentFilter } from 'context/establishments/EstablishmentFilter';
import FiltersModal from 'modules/events/filters/FiltersModal';
import EstablishmentFiltersModal from 'modules/establishment/filters/EstablishmentFiltersModal';
import SearchOverlay from 'modules/home/SearchOverlay';

export default function HomeHeader({
    visible,
    userView = false,
    mobileView,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { user } = useUser();
    const { isAuth } = useAuth();

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [firstLineToggle, setFirstLineToggle] = useState(false);
    const [secondLineToggle, setSecondLineToggle] = useState(false);
    const [visibleDropdown, setVisibleDropdown] = useState(false);
    const { isLateralMenuActive, setIsLateralMenuActive } = useOnSelectMenu()
    const { eventFilter, setEventFilter } = useEventFilter();
    const { establishmentFilter, setEstablishmentFilter } = useEstablishmentFilter();
    const { showSearchOverlay, setShowSearchOverlay } = useShowSearchOverlay();
    const overlaySearchRef = React.useRef(null);
    const isEstablishment = location.pathname.includes('/estabelecimentos');
    const isSearchPage = location.pathname === paths.events.search
        || location.pathname === paths.establishments.search;
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);

    const isEstablishmentRole = user?.role?.id == ROLES.ESTABLISHMENT || user?.role?.id == ROLES.ADMIN;

    function toggleMenu() {
        setFirstLineToggle(!firstLineToggle)
        setSecondLineToggle(!secondLineToggle)
        setIsLateralMenuActive(!isLateralMenuActive)
    }

    function toogleProfile() {
        setVisibleDropdown(!visibleDropdown)
    }

    function goToLogin() {
        navigate({
            pathname: paths.login,
            search: new URLSearchParams({
                ...Object.fromEntries(searchParams),
                redirectTo: location.pathname
            }).toString()
        })
    }

    return (
        <>
        <StyledHeader $mobileMap={mobileView === 'map'} $overlayOpen={showSearchOverlay} onClick={() => setVisibleDropdown(false)}>
            <WhizrLogo
                href={paths.home}
            >
                <Icon name={'whizr-inline-logo-dark'} />
            </WhizrLogo>

            {/*
                O painel de filtros abre na própria tela em qualquer página. Antes, fora
                da busca, o botão navegava para /buscar sem aplicar nem abrir filtro
                algum: o usuário perdia scroll e contexto e precisava clicar em "Filtros"
                de novo na tela nova. Os modais já são montados neste header e aplicam
                via contexto (useEventFilter), que a listagem observa.
            */}
            <DesktopSearchBar>
                <HeaderFilters
                    key={isEstablishment}
                    activeFilterCount={isEstablishment
                        ? (establishmentFilter
                            ? (establishmentFilter?.tags?.length || 0) +
                              (establishmentFilter?.features?.length || 0) +
                              (establishmentFilter?.dates ? 1 : 0) +
                              (establishmentFilter?.distance_range ? 1 : 0)
                            : 0)
                        : (eventFilter
                            ? (eventFilter?.categories?.length || 0) +
                              (eventFilter?.dates ? 1 : 0) +
                              (eventFilter?.classification_id ? 1 : 0) +
                              (eventFilter?.distance_range ? 1 : 0)
                            : 0)
                    }
                    onFilterClick={() => setIsFiltersOpen(true)}
                    onSearchSubmit={(term) => {
                        if (isSearchPage) {
                            const params = new URLSearchParams(searchParams);
                            if (term) params.set('search', term);
                            else params.delete('search');
                            navigate(location.pathname + '?' + params.toString());
                        } else if (showSearchOverlay) {
                            overlaySearchRef.current?.(term);
                        } else if (isEstablishment) {
                            setEstablishmentFilter(term ? { ...establishmentFilter, term } : null);
                        } else {
                            setEventFilter(term ? { ...eventFilter, term } : null);
                        }
                    }}
                    onInputClick={isSearchPage ? undefined : (showSearchOverlay ? undefined : () => setShowSearchOverlay(true))}
                />
            </DesktopSearchBar>

            <RightNavContainer>
                {
                    !isAuth ? (
                        <UnauthRow>
                            <HeaderLink onClick={() => navigate(paths.partner.createAccount)}>
                                <Plus size={15} />
                                <span>Crie seu evento</span>
                            </HeaderLink>
                            <LoginButtonWrapper>
                                <Button
                                    variant='featured'
                                    onClick={() => setIsLoginModalOpen(true)}
                                >
                                    <FullyCentered>
                                        <Column width='22px' height='22px'>
                                            <Icon name='login' color={colors.neutral} />
                                        </Column>
                                        <LoginButtonLabel>
                                            Entrar ou criar conta
                                        </LoginButtonLabel>
                                    </FullyCentered>
                                </Button>
                            </LoginButtonWrapper>
                        </UnauthRow>
                    ) : (
                        <>
                            {
                                !userView && (
                                    <HamburguerMenu onClick={(e) => {
                                        e.stopPropagation();
                                        toggleMenu();
                                        toogleProfile();
                                    }}>
                                        <HamburguerMenuLine firstLineToggle={firstLineToggle} />
                                        <HamburguerMenuLine secondLineToggle={secondLineToggle} />
                                    </HamburguerMenu>
                                )
                            }

                            <ContainerUser>
                                            <HeaderActionsRow>
                                                {
                                                    (!visible && user?.role?.id == ROLES.PRODUCER) && (
                                                        <HeaderLink onClick={() => navigate(paths.dashboard.events)}>
                                                            <Plus size={15} />
                                                            <span>Crie seu evento</span>
                                                        </HeaderLink>
                                                    )
                                                }
                                                {
                                                    (!isEstablishmentRole && (user?.role?.id != ROLES.PRODUCER) && !visible) && (
                                                        <HeaderLink onClick={() => navigate(paths.user.wallet)}>
                                                            <Tag size={15} />
                                                            <span>Meus ingressos</span>
                                                        </HeaderLink>
                                                    )
                                                }
                                                {
                                                    (user?.role?.id == ROLES.PRODUCER && !visible && !userView) && (
                                                        <ProducerButton onClick={() => navigate(paths.dashboard.statistics)}>
                                                            <ContentIcon>
                                                                <Icon name='pencil-square' color='#717680' />
                                                            </ContentIcon>
                                                            <span>Painel do produtor</span>
                                                        </ProducerButton>
                                                    )
                                                }
                                                {
                                                    (isEstablishmentRole && !visible && !userView) && (
                                                        <ProducerButton onClick={() => navigate(paths.dashboard.statistics)}>
                                                            <ContentIcon>
                                                                <Icon name='pencil-square' color='#717680' />
                                                            </ContentIcon>
                                                            <span>Painel de Eventos</span>
                                                        </ProducerButton>
                                                    )
                                                }
                                                {
                                                    (isEstablishmentRole && !visible && !userView) && (
                                                        <ProducerButton onClick={() => navigate(paths.dashboard.establishment.profile)}>
                                                            <ContentIcon>
                                                                <Icon name='pencil-square' color='#717680' />
                                                            </ContentIcon>
                                                            <span>Painel do Estabelecimento</span>
                                                        </ProducerButton>
                                                    )
                                                }
                                            </HeaderActionsRow>

                                            <ProfileMenu
                                                visible={visible}
                                                isOpen={visibleDropdown}
                                                onOpenChange={setVisibleDropdown}
                                            />
                            </ContainerUser>
                        </>
                    )
                }
                {/* <Text marginRight={'24px'} type='bold' color={colors.occasionalPurple}>
                    Torne-se um organizador
                </Text> */}
            </RightNavContainer>

        </StyledHeader>

        <SearchOverlay onRegisterSearch={(fn) => { overlaySearchRef.current = fn; }} />

        <LoginModal
            isOpen={isLoginModalOpen}
            onClose={() => setIsLoginModalOpen(false)}
        />
        {isEstablishment
            ? <EstablishmentFiltersModal
                isOpen={isFiltersOpen}
                onClose={() => setIsFiltersOpen(false)}
              />
            : <FiltersModal
                isOpen={isFiltersOpen}
                onClose={() => setIsFiltersOpen(false)}
              />
        }
        </>
    )
}


const StyledHeader = styled.header`
    display: flex;
    flex-direction: row;
    padding: 10px 16px;
    justify-content: space-between;
    align-items: center;
    background: ${colors.neutralBackground};
    position: sticky;
    top: 0;
    width: 100%;
    z-index: ${indexPriority.tremendous};
    box-shadow: 1px 1px 4px #ddd;

    ${({ $mobileMap }) => $mobileMap && `
        @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
            display: none;
        }
    `}

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 20px 20px;
        position: fixed;
        left: 0;
        border: 1px solid ${colors.neutralDark};
        z-index: ${indexPriority.header};
        box-shadow: ${({ $overlayOpen }) => $overlayOpen ? 'none' : '1px 1px 4px #ddd'};
        border-bottom-color: ${({ $overlayOpen }) => $overlayOpen ? 'transparent' : colors.neutralDark};
    }

    @media screen and (min-width: 1400px) {
        padding: 20px 40px;
    }
`;

const WhizrLogo = styled.a`
    width: 100px;
    height: 30px;
    cursor: pointer;
    transition: all ease-in-out .25s;

    &:hover {
        transform: scale(1.03)
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 120px;
        height: 40px;
    }
`;

const HamburguerMenu = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;

    @media screen and (min-width: ${breakpoints.lg}){
        display: none;
    }
`;

const HamburguerMenuLine = styled.div`
    display: block;
    width: 30px;
    background: ${colors.secondaryDark};
    height: 2px;
    margin: 5px 5px;
    transition: all 0.4s ease;
    z-index: 1;
    
    ${({ firstLineToggle }) => firstLineToggle && `
        transform: rotate(45deg) translate(8px, 2px);
    `}
    
    ${({ secondLineToggle }) => secondLineToggle && `
        transform: rotate(-45deg) translate(6px, 0px);
    `}

`;

const RightNavContainer = styled(Row)`
    width: auto;
    align-items: center;
    flex-direction: row-reverse;
    @media screen and (min-width: ${breakpoints.lg}) {
        margin-right: 25px;
    }
`;

const ContainerUser = styled.div`
    height: 55px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    @media screen and (min-width: ${breakpoints.md}) {
        margin-right: 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
`;

const UnauthRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    @media screen and (min-width: ${breakpoints.lg}) {
        gap: 16px;
    }
`;

const LoginButtonWrapper = styled.div`
    width: auto;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 220px;
    }

    & button {
        padding: 8px 12px !important;
        margin-bottom: 0 !important;

        @media screen and (min-width: ${breakpoints.lg}) {
            padding: 10px 16px !important;
        }
    }
`;

const LoginButtonLabel = styled.span`
    display: none;
    color: ${colors.neutral};
    font-weight: 600;
    font-size: 14px;
    margin-left: 8px;
    white-space: nowrap;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
    }
`;

const HeaderActionsRow = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-right: 12px;
    }

    @media screen and (min-width: 1400px) {
        gap: 24px;
        margin-right: 20px;
    }
`;

const HeaderLink = styled.div`
    display: none;
    align-items: center;
    gap: 6px;
    color: #717680;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }

    &:hover {
        color: #4a4d54;
    }
`;

const ProducerButton = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    color: #717680;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    padding: 8px 16px;
    border: 1.5px solid ${colors.night}22;
    border-radius: 10px;
    transition: all 0.2s ease;

    &:hover {
        background: ${colors.neutralDark};
        border-color: #BFBFBF;
        color: #4a4d54;
    }
`;

const ContentIcon = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 6px;

    ${({ wallet }) => wallet && `
        width: 20px;
        height: 20px;
        margin-right: 0px;
    `}

    ${({ qrcode }) => qrcode && `
        &:hover {
            & > svg {
                fill: ${colors.neutralLight}
            }
        }
    `}
`;



const DesktopSearchBar = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        align-items: center;
    }
`;